import Vue from 'vue';
import vConfirm from './v-confirm';

/**
 * @callback DialogFunction
 * @param {Object} config - Dialog configuration
 * @param {string} config.title - Title of the dialog
 * @param {string} config.content - Content of the dialog
 * @param {string} config.confirmLabel - Confirmation button label
 * @param {string} config.cancelLabel - Cancel button label
 */

/**
 * Creates a vue instance of the dialog component
 * and attached it to the parent component
 * @param dialogComponent
 * @param parentComponent
 * @return {DialogFunction}
 */
function createDialog(dialogComponent, parentComponent) {
    const ComponentClass = Vue.extend(dialogComponent);
    const instance = new ComponentClass();
    return function dialogFunction(props = {}) {
        const deferred = (isConfirmed) => {
            props.confirm = () => isConfirmed(true);
            props.cancel = () => isConfirmed(false);
            Object.assign(instance.$props, props);
            instance.$mount();
            parentComponent.$el.appendChild(instance.$el);
        };
        const promise = new Promise(deferred);
        promise.finally(() => {
            parentComponent.$el.removeChild(instance.$el);
            instance.$destroy();
        });
        return promise;
    };
}

export {
    createDialog,
    vConfirm,
};
